module Bookhus.Widgets {

	var localizedStrings = {
		flereTilbud: {
			"da": "Se flere tilbud",
			"en-GB": "See more deals",
			"de": "Mehr angebote",
			"sv": "Se fler erbjudanden",
			"no": "Se flere tilbud"
		},
		flereAfbud: {
			"da": "Se flere afbud",
			"en-GB": "See more cancellations",
			"de": "Mehr stornierungen",
			"sv": "Se fler avbokningar",
			"no": "Se flere avbestillinger"
		},
		flere: {
			"da": "Se flere",
			"en-GB": "See more",
			"de": "Mehr",
			"sv": "Se fler",
			"no": "Se flere"
		},
		tilbud: {
			"da": "Tilbud",
			"en-GB": "Deal",
			"de": "Angebote",
			"sv": "Anbud",
			"no": "Tilbud"
		},
		afbud: {
			"da": "Afbud",
			"en-GB": "Cancellation",
			"de": "Abgesagt",
			"sv": " Återbud",
			"no": "Avbestillinger"
		},
		book: {
			"da": "Book",
			"en-GB": "Book",
			"de": "Buch",
			"sv": " Bok",
			"no": "Bok"
		},
		info: {
			"da": "Info",
			"en-GB": "Info",
			"de": "Info",
			"sv": " Info",
			"no": "Info"
		},
		spar: {
			"da": "Spar",
			"en-GB": "Save",
			"de": "Sparen",
			"sv": "Spara",
			"no": "Spare"
		},
		standardpris: {
			"da": "Standard pris",
			"en-GB": "Standard price",
			"de": "Standartpreis",
			"sv": "Standard pris",
			"no": "Standard pris"
		},
		fra: {
			"da": "Fra",
			"en-GB": "From",
			"de": "Von",
			"sv": "Från",
			"no": "Fra"
		},
		til: {
			"da": "Til",
			"en-GB": "To",
			"de": "Zu",
			"sv": "Till",
			"no": "Til"
		},
		ingenafbud: {
			"da": "Der blev ikke fundet nogen afbud",
			"en-GB": "No recent cancellation found",
			"de": "No recent cancellation found",
			"sv": "No recent cancellation found",
			"no": "No recent cancellation found"
		},
		ingentilbud: {
			"da": "Der blev ikke fundet nogen tilbud",
			"en-GB": "No recent offers found",
			"de": "No recent offers found",
			"sv": "No recent offers found",
			"no": "No recent offers found"
		},
		viskatalog: {
			"da": "Se katalog",
			"en-GB": "See catalog",
			"de": "See catalog",
			"sv": "See catalog",
			"no": "See catalog"
		}
	}

    export interface IRecentListingProps {
		displayOffers: boolean;
		displayCancellations: boolean;
		culture: string;
	}

	interface ICarouselItem {
		imageUrl: string;
		header: string;
		subheader: string;
		description: string;
		actions: IAction[];
		periodDescription: string;
	}

	interface IAction {
		url: string;
		text: string;
		class: string;
		description: string;
    }

	enum ListingType {
		Offers,
		Cancellations,
		Highlighted,
		Random
	}

    export class RecentListing {

        private props: IRecentListingProps;
		private container: JQuery;

        private constructor(container: JQuery, props: IRecentListingProps) {
            this.props = props;
            this.container = container;
            this.buildContainer();
        }

		private buildContainer(): void {

			var tabNavigation = this.buildTabNavigation();
			tabNavigation.appendTo(this.container);

			if (this.props.displayOffers) {
				this.buildListing(tabNavigation, ListingType.Offers);
				
			}

			if (this.props.displayCancellations) {
				this.buildListing(tabNavigation, ListingType.Cancellations);
			}

			(tabNavigation as any).init();
		}

		private buildTabNavigation(): JQuery {
			var $container = $(`
                <div class="d-flex justify-content-center justify-content-md-between pb-3">
				    <ul role="tablist" class="nav nav-pills text-uppercase">
				    </ul>
			    </div>
				<div class="tab-content" >
				</div>
            `);

            ($container as any).getTabId = (listingType: ListingType) => {
				return 'listing_tab_' + listingType;
            };

            ($container as any).getTabName = (listingType: ListingType) => {
				switch (listingType)
				{
					case ListingType.Offers:
						return localizedStrings.tilbud[this.props.culture] || 'Tilbud';
					case ListingType.Cancellations:
						return localizedStrings.afbud[this.props.culture] || 'Afbud';
					default:
						return '';
				}
            };

            ($container as any).addTab = (listingType: ListingType) => {

            var tabId = ($container as any).getTabId(listingType);
            var tabName = ($container as any).getTabName(listingType);

            $('ul', $container).append(`
            <li class="nav-item">
            <a data-toggle="tab" role="tab" class="nav-link btn font-weight-bold font-size-1" href="#${tabId}">${tabName}</a>
            </li>
            `);

            $('.tab-content', $container.parent()).append(`
            <div class="tab-pane fade" id="${tabId}" role="tabpanel">
            </div>
            `);
            }

            ($container as any).getTabPane = (listingType: ListingType) => {
				var tabId = ($container as any).getTabId(listingType);
				return $container.find(`#${tabId}`);
            }

            ($container as any).init = () => {
				$('ul.nav li:first-child a').tab('show');
            };

			return $container;
		}

		private buildCarousel(listingType: ListingType): JQuery {
			var $container = $(`
				<div data-interval="false" class="carousel slide" data-ride="carousel">
					<div class="carousel-controls d-flex justify-content-center justify-content-md-end px-4 pb-3">
						
					</div>
					<div class="carousel-inner">
					</div>
				</div>
			`);

			($container as any).getCarouselId = (listingType: ListingType) => {
				return 'listing_carousel_' + listingType;
			};
			$container.attr('id', ($container as any).getCarouselId(listingType));

			($container as any).getCarouselName = (listingType: ListingType) => {
				switch (listingType) {
					case ListingType.Offers:
						return localizedStrings.tilbud[this.props.culture] || 'Tilbud';
					case ListingType.Cancellations:
						return localizedStrings.afbud[this.props.culture] || 'Afbud';
					default:
						return '';
				}
			};

			($container as any).addControls = (listingType: ListingType, itemsCount: number) => {
				var indicators = '';
				for (var i = 0; i < itemsCount; i++) {
					indicators += `<li data-target="#${($container as any).getCarouselId(listingType)}" data-slide-to="${i}" class="${i == 0 ? 'active' : ''}"></li>`;
                }

				$('.carousel-controls', $container).append(`
					<a class="carousel-control-prev text-secondary"  href="#${($container as any).getCarouselId(listingType)}" role="button" data-slide="prev">
							<i class="fal fa-long-arrow-left"></i>
					</a>
					<ol class="carousel-indicators">
						${indicators}
					</ol>
					<a class="carousel-control-next text-secondary" href="#${($container as any).getCarouselId(listingType)}" role="button" data-slide="next">
						<i class="fal fa-long-arrow-right"></i>
					</a>
				`);
			}

			($container as any).addItem = (item: ICarouselItem, active: boolean) => {
				var actionHtml = '';
				if (item.actions && item.actions.length > 0) {
					actionHtml =
						item.actions
							.map((action, index) => {
								return `<a href="${action.url}" class="${action.class}" aria-label="${action.description}">${action.text}</a>`;
							})
							.join('');
				}

				$('.carousel-inner', $container).append(`
					<div class="carousel-item ${active ? 'active' : ''}">
						<div class="card p-4">
							<div class="row">
								<div class="col-md-5 mb-4 mb-md-0">
									<div class="carousel-media bg-gray rounded">
										${item.imageUrl && item.imageUrl.length > 0 ? `<img src="${item.imageUrl}" class="rounded" alt="">` : '<i class="icon-home"></i>'}
									</div>
								</div>
								<div class="col-md-6 offset-md-1 d-flex flex-column">
									<h2 class="text-uppercase text-secondary font-weight-bold mb-3">${item.header}</h2>
									<h5 class="font-weight-bold text-uppercase text-dark">${item.subheader}</h5>
									<p class="flex-grow-1 text-black-50">
										${item.description}
									</p>
									<div class="d-flex mb-2">
										${actionHtml}
									</div>
									<p class="text-black-50 mb-0">
										${item.periodDescription}
									</p>
								</div>
							</div>
						</div>
					</div>
				`);
			}

			($container as any).init = () => {
				$container.find('ul li:first')
				$container.carousel();
			};

			return $container;
		}

		private buildListing(tabNavigation: JQuery, listingType: ListingType): void {

			(tabNavigation as any).addTab(listingType);

			var carousel = this.buildCarousel(listingType);
			this.loadListing(1, listingType).then((result) => {
				if (result.length > 0) {

					(carousel as any).addControls(listingType, result.length);
					result.forEach((deal, index) => {
						var carouselItem = this.parseDeal(deal);
						(carousel as any).addItem(carouselItem, index == 0);
					});
				}
				else {
					(carousel as any).addItem({
						imageUrl: '',
						header: '',
						subheader: listingType == ListingType.Offers ? localizedStrings.ingentilbud[this.props.culture] : localizedStrings.ingenafbud[this.props.culture],
						description: '',
						actions: [
							{ url: `/catalog`, text: localizedStrings.viskatalog[this.props.culture], class: 'btn btn-outline-dark text-nowrap', description: `Gå til katalog` } as IAction
						],
						periodDescription: ''
					} as ICarouselItem, true);
				}


				var tabPane = (tabNavigation as any).getTabPane(listingType);
				carousel.appendTo(tabPane);
				(carousel as any).init();
			});
        }

		private loadListing(page: number, listingType: ListingType): Promise<IDeal[]> {
			return new Promise((succes, error) => {
				var xhr = $.getJSON(`/api/deallist/Get?pagenumber=${page}&type=${listingType}&rowsPerPage=5`);

				xhr.done((data: IDeal[]) => {
					if (data && data.length > 0) {
						succes(data);
					}
					else {
						succes([]);
                    }
				});

				xhr.fail(() => {
					error('Kunne ikke hente opslaget');
				});
			});
		}

		private parseDeal(deal: IDeal): ICarouselItem {

			var fromdate = new Date(deal.fromdateRfc1123);
			var fromtime = fromdate.toString("HH:mm");

			var todate = new Date(deal.todateRfc1123);
			var totime = todate.toString("HH:mm");

			var carouselItem = {
				imageUrl: `/houseimage/${deal.house.imageId}`,
				header: `${localizedStrings.standardpris[this.props.culture]} ${deal.priceString}`,
				subheader: deal.house.title,
				description: deal.selectedAttributes,
				periodDescription: `${localizedStrings.fra[this.props.culture]} ${fromdate.formatDate("dd-mm-yy")} ${fromtime} ${localizedStrings.til[this.props.culture]} ${todate.formatDate("dd-mm-yy")} ${totime}`
			} as ICarouselItem;

			var listingType = deal.type as ListingType;
			switch (listingType) {
				case ListingType.Offers:
					$.extend(carouselItem, {
						header: `${localizedStrings.spar[this.props.culture]} ${deal.priceString}`,
						actions: [
							{ url: `/book/${deal.house.id}`, text: localizedStrings.book[this.props.culture], class: 'btn btn-outline-dark text-nowrap w-100 mr-3', description: `Book ${deal.bookDescription} ${carouselItem.periodDescription}` } as IAction,
							{ url: `/house/${deal.house.id}`, text: localizedStrings.info[this.props.culture], class: 'btn btn-primary text-nowrap w-100 mr-3', description: `Vis information om ${deal.bookDescription}` } as IAction,
							{ url: '/booking/tilbudlist', text: localizedStrings.flereTilbud[this.props.culture], class: 'btn btn-secondary text-nowrap w-100 mr-3', description: '' } as IAction,
						]
					});
					break;
				case ListingType.Cancellations:
					$.extend(carouselItem, {
						actions: [
							{ url: `/book/${deal.house.id}`, text: localizedStrings.book[this.props.culture], class: 'btn btn-outline-dark text-nowrap w-100 mr-3', description: `Book ${deal.bookDescription} ${carouselItem.periodDescription}` } as IAction,
							{ url: `/house/${deal.house.id}`, text: localizedStrings.info[this.props.culture], class: 'btn btn-primary text-nowrap w-100 mr-3', description: `Vis information om ${deal.bookDescription}` } as IAction,
							{ url: '/booking/cancellationlist', text: localizedStrings.flereAfbud[this.props.culture], class: 'btn btn-secondary text-nowrap w-100 mr-3', description: '' } as IAction,
						]
					});
					break;
			}

			return carouselItem
        }

        public static init(target: string, props: IRecentListingProps): void {
            var extendedProps = $.extend({

            }, props);

            const RECENT_LISTING_NAME = 'recent_listing_instance';
            $(target).each((index, element) => {
                var $element = $(element);
                if (!$element.data(RECENT_LISTING_NAME)) {
                    $element.data(RECENT_LISTING_NAME, new RecentListing($element, extendedProps));
                }
            });
        }
    }
}